// AccountSidebar.js
import React from "react";
import {
  Box,
  VStack,
  Text,
  Button,
  Divider,
  useDisclosure,
  useColorModeValue,
} from "@chakra-ui/react";
import { SurveyPopup } from "../Popups";
import { useHistory } from "react-router-dom";

export default function AccountSidebar({ active, onSelect }) {
  const bg = useColorModeValue("gray.50", "gray.800");
  const bgHover = useColorModeValue("gray.100", "gray.600");

  const history = useHistory();

  const {
    isOpen: isSurveyOpen,
    onOpen: onOpenSurvey,
    onClose: onCloseSurvey,
  } = useDisclosure(); // Renamed this for clarity

  const handleSurveyPopupClose = () => {
    onCloseSurvey(); // Use the correct close function from `useDisclosure`
  };

  // Helper to render sidebar items
  const renderItem = (label) => {
    // Special case for 'Give Us Feedback'
    if (label === "Give Us Feedback") {
      return (
        <Button
          key={label}
          variant="ghost"
          justifyContent="flex-start"
          fontWeight={active === label ? "bold" : "normal"}
          color={active === label ? "black" : "gray.500"}
          _hover={{ bg: bgHover }}
          w="100%"
          px={3}
          py={2}
          size="sm"
          borderRadius="md"
          onClick={onOpenSurvey}
        >
          {label}
        </Button>
      );
    }
    // Special case for 'Terms of Service'
    if (label === "Terms of Service") {
      return (
        <Button
          key={label}
          variant="ghost"
          justifyContent="flex-start"
          fontWeight={active === label ? "bold" : "normal"}
          color={active === label ? "black" : "gray.500"}
          _hover={{ bg: bgHover }}
          w="100%"
          px={3}
          py={2}
          size="sm"
          borderRadius="md"
          onClick={() => history.push("/policies/terms-of-service")}
        >
          {label}
        </Button>
      );
    }
    // Special case for 'Privacy Policy'
    if (label === "Privacy Policy") {
      return (
        <Button
          key={label}
          variant="ghost"
          justifyContent="flex-start"
          fontWeight={active === label ? "bold" : "normal"}
          color={active === label ? "black" : "gray.500"}
          _hover={{ bg: bgHover }}
          w="100%"
          px={3}
          py={2}
          size="sm"
          borderRadius="md"
          onClick={() => history.push("/policies/privacy-policy")}
        >
          {label}
        </Button>
      );
    }
    // Default behavior for other items
    return (
      <Button
        key={label}
        variant="ghost"
        justifyContent="flex-start"
        fontWeight={active === label ? "bold" : "normal"}
        color={active === label ? "black" : "gray.500"}
        _hover={{ bg: bgHover }}
        w="100%"
        px={3}
        py={2}
        size="sm"
        borderRadius="md"
        onClick={() => onSelect(label)}
      >
        {label}
      </Button>
    );
  };

  return (
    <Box
      w="220px"
      h="100%"
      bg={bg}
      borderRight="1px solid"
      borderColor={useColorModeValue("gray.200", "gray.700")}
      p={4}
    >
      <VStack align="stretch" spacing={1}>
        <Text fontSize="xs" color="gray.500" mb={1}>
          GENERAL SETTINGS
        </Text>
        {["Account", "Notification", "Give Us Feedback"].map(renderItem)}

        <Divider my={4} />

        <Text fontSize="xs" color="gray.500" mb={1}>
          PRIVACY
        </Text>
        {["Terms of Service", "Privacy Policy"].map(renderItem)}
      </VStack>
      <SurveyPopup isOpen={isSurveyOpen} onClose={handleSurveyPopupClose} />
    </Box>
  );
}
